// extracted by mini-css-extract-plugin
export default {"container":"styles_container__zeDt4","imageContainer":"styles_imageContainer__hmaHb","waveImage":"styles_waveImage__SHXpY","waffyImage":"styles_waffyImage__V6b24"};